import { Title, CanAccess } from 'react-admin';
import MailCapStatusWidget from './DashboardWidgets/MailCapStatusWidget';
import LatestRemarksWidget from './DashboardWidgets/LatestRemarksWidget';
import LatestScansWidget from './DashboardWidgets/LatestScansWidget';
import { ReactElement } from 'react';

export default function Dashboard(): ReactElement {
  return (
    <>
      <Title title="Getprice CMS" />
      <br />
      <CanAccess resource="merchants" action="list">
        <CanAccess resource="merchant_spendings" action="list">
          <MailCapStatusWidget />
        </CanAccess>
      </CanAccess>
      <br />
      <CanAccess resource="merchants" action="list">
        <CanAccess resource="merchant_remarks" action="list">
          <LatestRemarksWidget />
        </CanAccess>
      </CanAccess>
      <br />
      <CanAccess resource="merchants" action="list">
        <CanAccess resource="scans" action="list">
          <LatestScansWidget />
        </CanAccess>
      </CanAccess>
    </>
  );
}
